import { useContext } from 'react'
import { ArtsLimitUpsellContext } from './ArtsLimitUpsellContext'

export const useArtsLimitUpsell = () => {
  const context = useContext(ArtsLimitUpsellContext)

  if (!context) {
    throw new Error('useArtsLimitUpsell must be used within ArtsLimitUpsellProvider')
  }

  return context
}
